import { render } from "./Quant.vue?vue&type=template&id=28268bfe&scoped=true"
import script from "./Quant.vue?vue&type=script&lang=js"
export * from "./Quant.vue?vue&type=script&lang=js"

import "./Quant.vue?vue&type=style&index=0&id=28268bfe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28268bfe"]])

export default __exports__